import { GraphQLObjectType, GraphQLList, GraphQLNonNull, GraphQLID, GraphQLBoolean } from 'graphql';
import { toGlobalId } from 'graphql-relay';

import ReviewQuestionType from './reviewQuestionType.gql';
import QuestionResponseType from './questionResponse.gql';
import UserType from './user.gql';

const peerSubmissionReviewType = new GraphQLObjectType({
  name: 'PeerSubmissionReview',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID),
      resolve: (item) => {
        const offerId = item._id.toString();
        const rootOfferId = item.rootOfferId.toString();
        return toGlobalId('PeerSubmissionReview', `${offerId}-${rootOfferId}`);
      }
    },
    peerReview: {
      type: new GraphQLList(ReviewQuestionType),
      resolve: (item) => {
        const questions = item.children.map(child => ({
          pid: child._id,
          ...child.content.question,
          maxScore: child.maxScore,
          minScore: child.minScore
        }));
        return questions;
      }
    },
    isReviewed: {
      type: GraphQLBoolean
    },
    answer: {
      type: QuestionResponseType
    },
    user: {
      type: UserType,
      resolve: () => ({
        id: '123',
        pid: '121212',
        name: 'swaraj'
      })
    }
  })
});

window[peerSubmissionReviewType.name + 'GQLType'] = peerSubmissionReviewType;

export default peerSubmissionReviewType;
